import React from 'react';
import './WaveCard.scss';

function WaveCard(props) {
  const { data } = props;
  return (
    <div className='d-flex gap-3 flex-wrap p-3'>
      {data?.map((item, i) => (
        <div
          key={i}
          className='wave-card-container p-4 position-relative d-flex align-items-start justify-content-start'
        >
          <div className='bg-wrapper'></div>
          <div className='wave-card d-flex flex-column'>
            <span className=' fs-4 fw-bold'>{item.formattedCount}</span>
            <span className='fs-7'>{item.country}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default WaveCard;
